export const SELECT_RECEIPT_TO_STORNO = 'SELECT_RECEIPT_TO_STORNO';
export const SELECT_RECEIPT_TO_PRINT = 'SELECT_RECEIPT_TO_PRINT';
export const SELECT_RECEIPT_TO_SHOW = 'SELECT_RECEIPT_TO_SHOW';

export const SELECT_RECEIPT_TO_STORNO_ONLINE = 'SELECT_RECEIPT_TO_STORNO_ONLINE';
export const SELECT_RECEIPT_TO_PRINT_ONLINE = 'SELECT_RECEIPT_TO_PRINT_ONLINE';
export const SELECT_RECEIPT_TO_SHOW_ONLINE = 'SELECT_RECEIPT_TO_SHOW_ONLINE';

export function selectReceiptToStornoOnline(receipt) {
    return {
        type: SELECT_RECEIPT_TO_STORNO_ONLINE,
        payload: receipt
    }
}

export function selectReceiptToPrintOnline(receipt) {
    return {
        type: SELECT_RECEIPT_TO_PRINT_ONLINE,
        payload: receipt
    }
}

export function selectReceiptToShowOnline(receipt) {
    return {
        type: SELECT_RECEIPT_TO_SHOW_ONLINE,
        payload: receipt
    }
}

export function selectReceiptToStorno(receiptNumber) {
    return {
        type: SELECT_RECEIPT_TO_STORNO,
        payload: receiptNumber
    }
}

export function selectReceiptToPrint(receiptNumber) {
    return {
        type: SELECT_RECEIPT_TO_PRINT,
        payload: receiptNumber
    }
}

export function selectReceiptToShow(receiptNumber) {
    return {
        type: SELECT_RECEIPT_TO_SHOW,
        payload: receiptNumber
    }
}



// WEBPACK FOOTER //
// ./src/common/storno/actions.js